module.exports = __webpack_public_path__ + "img/music-note-list.d5806502.svg";